import React from "react";
import {
  breakpointClasses,
  cls,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { TypographyH1Props } from "../types";

function TypographyH1({ as, asChild, className, ...props }: TypographyH1Props) {
  const Component = resolveElement(asChild, as, "h1");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Typography.H1] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(
        cls`
          scroll-m-20
          ~text-2xl/6xl
          font-header font-medium
          ~leading-tight/[1.2]
        `,
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default TypographyH1;
